import throttle from 'lodash/throttle';

interface MyWindow extends Window {
  throttle: typeof throttle;
}

declare let window: MyWindow;

window.throttle = throttle;
